import { createRoot } from 'react-dom/client'
import App from './App.tsx'
import './index.css'
import { StrictMode, lazy, Suspense } from 'react'
import { HelmetProvider } from 'react-helmet-async'
import { initDataFast } from './lib/analytics/datafast'

const COOKIE_CONSENT_KEY = 'cookie-consent';
const posthogKey = import.meta.env.VITE_PUBLIC_POSTHOG_KEY;
const hasConsent = localStorage.getItem(COOKIE_CONSENT_KEY) === 'accepted';
const usePostHog = hasConsent && !!posthogKey;

const options = {
  api_host: import.meta.env.VITE_PUBLIC_POSTHOG_HOST,
  defaults: '2025-05-24',
} as const;

initDataFast();

// Lazy-load PostHog wrapper to keep it out of the initial JS bundle
const PostHogApp = usePostHog
  ? lazy(async () => {
      const { PostHogProvider } = await import('posthog-js/react');
      return {
        default: () => (
          <PostHogProvider apiKey={posthogKey} options={options}>
            <App />
          </PostHogProvider>
        ),
      };
    })
  : null;

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <HelmetProvider>
      {PostHogApp ? (
        <Suspense fallback={<App />}>
          <PostHogApp />
        </Suspense>
      ) : (
        <App />
      )}
    </HelmetProvider>
  </StrictMode>
);
